var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatreonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.46666 135.46667",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(0.19862789,0,0,0.19862789,16.933333,16.884593)",
    style: {
      fill: "#f4511e",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4511e",
      fillOpacity: 1
    },
    d: "M 303.14673,376.3884 C 224.01887,365.64349 160.53129,304.5225 146.93532,226 133.29061,147.19601 172.66595,68.341846 244,31.615575 302.86222,1.3104097 372.5873,4.7639257 427.94975,40.726693 c 31.61825,20.538828 57.34215,52.052185 70.7954,86.728717 25.23454,65.04351 12.54664,136.5194 -33.57751,189.15519 -28.94957,33.03657 -72.21623,55.46251 -116.37823,60.32107 -12.94171,1.42381 -32.90672,1.18617 -45.64268,-0.54327 z",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4511e",
      fillOpacity: 1
    },
    d: "M 0,256 V 11 H 45 90 V 256 501 H 45 0 Z",
    id: "path2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatreonIcon);
export default __webpack_public_path__ + "static/media/patreon-icon.c8f7d015d302c0adb9fed486d4f5e61d.svg";
export { ForwardRef as ReactComponent };